export default "__VITE_ASSET__DrJhJ_nB__"